import React from 'react';
import PropTypes from 'prop-types';
import Word from './word/Word';
import './OlRow.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const OlRow = ({ sentence, result, correctnessMark, number }) => (
    <div className="row">
        <p className="col-9 ol-words-container">
            <span className="number">{number}.</span>
            {sentence.map((word, index) => (
                <Word
                    {...word}
                    key={generateReactKey(index)}
                    sentenceLength={sentence.length}
                    wordPosition={index}
                />
            ))}
        </p>
        {correctnessMark}
        <span className="col-1 score-mark">{result}</span>
    </div>
);

OlRow.defaultProps = {
    sentence: [],
    result: 0,
    correctnessMark: <></>,
    number: 0,
};

OlRow.propTypes = {
    sentence: PropTypes.array,
    result: PropTypes.number,
    correctnessMark: PropTypes.element,
    number: PropTypes.number,
};

export default OlRow;
